import { AgentConversation } from '../../../services/api/aiAgentApi/aiAgent';

export function conversationNeedsApproval(agentConversation: AgentConversation) {
  return agentConversation.status === `awaiting_approval` || (agentConversation.pending_task_count || 0) > 0;
}

export function conversationHasFailure(agentConversation: AgentConversation) {
  return (agentConversation.failed_run_count || 0) > 0;
}

export function getRunStatusMeta(status: string): { label: string; color: `gray` | `red` | `yellow` | `green` | `blue` | `orange` | `purple` } {
  switch (status) {
  case `queued`:
    return { label: `Queued`, color: `gray` };
  case `running`:
    return { label: `Running`, color: `blue` };
  case `completed`:
  case `succeeded`:
    return { label: `Completed`, color: `green` };
  case `failed`:
    return { label: `Failed`, color: `red` };
  default:
    return { label: status.replace(/_/g, ` `), color: `gray` };
  }
}

export function formatLocalTimestamp(value: string) {
  return new Intl.DateTimeFormat(undefined, {
    day: `2-digit`,
    month: `short`,
    hour: `2-digit`,
    minute: `2-digit`,
    hour12: false,
  }).format(new Date(value));
}
